module.exports = __webpack_public_path__ + "static/media/lock.ac56cf89.svg";